"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC1967ProxyWithAdminControlFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_logic",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "_data",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "timestamp",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementationAddress",
                type: "address",
            },
        ],
        name: "ImplementationChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newAdmin",
                type: "address",
            },
        ],
        name: "changeProxyAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getProxyAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "_newImplementation",
                type: "address",
            },
        ],
        name: "upgradeTo",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        stateMutability: "payable",
        type: "receive",
    },
];
const _bytecode = "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";
class ERC1967ProxyWithAdminControlFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_logic, _data, overrides) {
        return super.deploy(_logic, _data, overrides || {});
    }
    getDeployTransaction(_logic, _data, overrides) {
        return super.getDeployTransaction(_logic, _data, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.ERC1967ProxyWithAdminControlFactory = ERC1967ProxyWithAdminControlFactory;
ERC1967ProxyWithAdminControlFactory.bytecode = _bytecode;
ERC1967ProxyWithAdminControlFactory.abi = _abi;
//# sourceMappingURL=ERC1967ProxyWithAdminControlFactory.js.map